import { RouteComponentProps } from "@gatsbyjs/reach-router";
import { APAsyncButton, APCard, APCenter, APColumn, APSizedBox, APText, getIt, handleErrorMessage, showErrorDialog, sleep } from "ap-components";
import React, { useEffect, useState } from "react";
import SharedPrefs from "../../Services/SharedPrefs";
import MandateModel from '../../Models/Mandate';
import { Heading, Icons, Note } from "./index";
import LoadingState from "./LoadingState";
import MandateScrollContainer from "./MandateScrollContainer";
import MutualFundApiServices from "../../Services/MutualFundServices";


export function AutoPayInstruction(props: RouteComponentProps<{ mandateId: string }>) {
    const [mandate, setMandate] = useState<MandateModel>();

    useEffect(() => {
        getMandate()
    }, [])

    const mandateToken = getIt(SharedPrefs).getItem('mandateTkn');
    if (!mandateToken) {
        window.location.href = "/"
        showErrorDialog("Unauthorized Access");
        return <></>
    }

    if (!props.mandateId) {
        window.history.back();
        showErrorDialog("Please select correct mandate");
        return <></>
    }

    async function getMandate() {
        if (!mandateToken || !props.mandateId) {
            return
        }

        try {
            const res = await getIt(MutualFundApiServices).getMandate(props.mandateId, mandateToken);
            setMandate(res);
        } catch (error) {
            handleErrorMessage(error);
            await sleep(3000)
            window.location.href = "/"
        }
    }

    if (!mandate) {
        return <LoadingState />
    }

    if (mandate.bseStatus !== 'REGISTERED BY MEMBER') {
        return (
            <APColumn mainAxisSize="max" crossAxisAlignment="stretch" >
                <APCenter>
                    <APCard style={{ padding: "16px", borderRadius: "8px" }}>
                        <APText style={{ fontSize: "14px", lineHeight: 1.43, color: "#606c84" }}>
                            Process already completed, you may close the page now.
                        </APText>
                    </APCard>
                </APCenter>
            </APColumn >
        )
    }

    let mandateType = mandate.getMandateType();

    return (
        <MandateScrollContainer
            scrollContent={
                <APColumn crossAxisAlignment="stretch">
                    <AutoPaySetup mandate={mandate} />
                    <APSizedBox height="4px" />
                    {
                        mandate.isAutoGenerated === true && mandateType === "Offline" &&
                        <APText style={{ fontSize: "12px", lineHeight: 1.33, color: "#41495b" }}>Changed your mind?&nbsp;
                            <span style={{ fontWeight: 500, color: "#5745ba", textDecoration: "underline" }} onClick={async () => {
                                try {
                                    const res = await getIt(MutualFundApiServices).registerMandateExistingToNew({ mandateId: mandate._id, mandateType: 'N' }, mandateToken);
                                    window.location.href = `/mandate/${res._id}/review`;
                                } catch (error) {
                                    handleErrorMessage(error);
                                }
                            }}>Click here</span>
                            &nbsp;to setup via Netbanking
                        </APText>
                    }
                    {
                        mandate.isAutoGenerated === true && mandateType === "Online" &&
                        <APText style={{ fontSize: "12px", lineHeight: 1.33, color: "#41495b" }}>Looking for offline AutoPay Setup?&nbsp;
                            <span style={{ fontWeight: 500, color: "#5745ba", textDecoration: "underline" }}
                                onClick={async () => {
                                    try {
                                        const res = await getIt(MutualFundApiServices).registerMandateExistingToNew({ mandateId: mandate._id, mandateType: 'X' }, mandateToken);
                                        window.location.href = `/mandate/${res._id}/review`;
                                    } catch (error) {
                                        handleErrorMessage(error);
                                    }
                                }}>Click here</span>
                        </APText>
                    }
                </APColumn>
            }

            actions={
                <APColumn gap="16px" crossAxisAlignment="stretch">
                    <Note text="Join 1 lakh+ users in opting to AutoPay." />
                    <APAsyncButton
                        onClick={async () => {
                            window.location.href = `/mandate/${mandate._id}/review`;
                        }}
                    >
                        Continue
                    </APAsyncButton>
                </APColumn>
            }
        />
    );
}

export function AutoPaySetup({mandate} : { mandate?: MandateModel }) {
    return (
        <APCard style={{ padding: "16px", borderRadius: "8px" }}>
            <APColumn gap="16px" crossAxisAlignment="stretch">
                <Heading text={"Setup AutoPay now"} desc={"With AutoPay, SIP investments are made automatically from your preferred bank."} />
                <APText style={{ fontSize: "12px", lineHeight: 1.33, color: "#232730" }}>
                    BENEFITS OF AUTO PAY:
                </APText>
                <Icons icon={"ic_one_time_setup"} text={"One time setup"} />
                <Icons icon={"ic_automatic_sip_payments"} text={"Automatic SIP payments"} />
                <Icons icon={"ic_sip"} text={"Never miss an SIP"} />
                <Icons icon={"ic_no_deduction"} text={"No deductions without your authorization"} />
                {mandate && mandate.mandateType == 'U' && <Note text="A Re.1 debit will be made to confirm your mandate setup." />}
            </APColumn>
        </APCard>
    )
}
